<template>
  <div>
    <template v-if="componentType === 'v-text-field' || componentType === 'v-textarea'">
      <component :is="componentType" v-model="obj[fieldText]"
                 :hint="(obj[fieldText] && !obj[field]) || (translation && translation._new) ? $t('translations.new_translation_will_be_made') : ''"
                 :readonly="!!obj[field] && (!translation || (translation && !translation._new))"
                 auto-grow
                 persistent-hint
                 v-bind="$attrs"
                 @blur="(e) => setTranslation({translation: obj[fieldText], tid: obj[field]})"
      >
        <template v-slot:append>
          <v-btn v-if="obj[fieldText] || obj[field]" class="mr-2" icon small text @click="() => {
                          obj[fieldText] = '';
                          obj[field] = null;
                      }">
            <v-icon>mdi mdi-close</v-icon>
          </v-btn>
          <v-btn :color="obj[field] ? 'info' : ''" icon small text
                 @click="openTranslationSelect(field)">
            <v-icon>mdi mdi-translate</v-icon>
          </v-btn>
        </template>
      </component>
    </template>
    <template v-if="componentType === 'v-combobox'">
      <v-combobox
        :hint="(obj[fieldText] && !obj[field]) || (translation && translation._new) ? $t('translations.new_translation_will_be_made') : ''"
        :items="translations"
        :readonly="!!obj[field]"
        :value="obj[fieldText]"
        item-text="translation"
        item-value="tid"
        persistent-hint v-bind="$attrs"
        @input="setTranslation">
        <template v-slot:append>
          <v-btn v-if="obj[fieldText] || obj[field]" class="mr-2" icon small text @click="() => {
                          obj[fieldText] = '';
                          obj[field] = null;
                      }">
            <v-icon>mdi mdi-close</v-icon>
          </v-btn>
          <v-btn :color="obj[field] ? 'info' : ''" icon small text
                 @click="openTranslationSelect(field)">
            <v-icon>mdi mdi-translate</v-icon>
          </v-btn>
        </template>
      </v-combobox>
    </template>

    <select-translation-dialog ref="selectTranslationDialog" :prefix="prefix"
                               @selected="setTranslation"></select-translation-dialog>
  </div>
</template>

<script>
import SelectTranslationDialog from "@/components/SelectTranslationDialog";
import TranslationService from "@/service/translation.service";

export default {
  name: "TranslationInput",
  components: {SelectTranslationDialog},
  props: {
    obj: {
      type: Object,
      required: true
    },
    field: {
      type: String,
      required: true
    },
    componentType: {
      type: String,
      required: false,
      default: "v-text-field"
    },
    prefix: {
      type: String,
      required: false,
      default: ""
    },
  },
  computed: {
    fieldText() {
      return this.$tidTextField(this.field);
    },
    translations() {
      return TranslationService.ct.filter(t => t.tid.startsWith(this.prefix + "."))
    },
    translation() {
      return this.translations.find(t => t.tid === this.obj[this.field]);
    }
  },
  methods: {
    openTranslationSelect(field) {
      this.$refs.selectTranslationDialog.open(field, this.obj[field]);
    },
    setTranslation(translation) {

      if (typeof translation === 'object') {
        if (!translation.tid) {
          translation = TranslationService.setNewTranslation(translation.translation, null, this.prefix);
        } else {
          translation = TranslationService.setTranslation(translation.tid, translation.translation, null);
        }
        this.obj[this.field] = translation?.tid || null;
        this.obj[this.fieldText] = translation?.translation || null;
      } else { // Combobox, create new
        const t = TranslationService.setNewTranslation(translation, null, this.prefix);
        this.obj[this.field] = t?.tid || null;
        this.obj[this.fieldText] = t?.translation || null;
      }
    },
    setTextFields() {
      this.$nextTick(() => {

        if (this.obj[this.fieldText] === void 0) {
          this.$set(this.obj, this.fieldText, null);
        }
        this.$nextTick(() => {

          this.obj[this.fieldText] = this.translation?.translation;
        })
      })
    }

  },
  created() {
    TranslationService.$on('translations-changed', this.setTextFields);
  },
  beforeDestroy() {
    TranslationService.$off('translations-changed', this.setTextFields);
  },
  watch: {
    translations() {
      this.setTextFields();
    }
  },
  mounted() {
    this.setTextFields();
  }
}
</script>

<style scoped>

</style>
